module.exports = __webpack_public_path__ + "img/bg-2.0195ca1f.png";